<template>
  <div class="antialiased">
    <Sidebar />
    <div class="page">
      <Header @change="_search" hint="Ketik nama toko" />

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">Toko</h2>
              </div>

              <!-- <div class="col-auto">
                <div class="text-muted text-h5 mt-2">Login Pada {{auth.logged_at}}</div>
              </div> -->

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto px-0">
                    <div class="input-icon">
                      <span class="input-icon-addon">
                        <i class="fe fe-align-left"></i>
                      </span>
                      <select
                        class="form-control"
                        v-model="data_filter.per_page"
                        @change="_get()"
                        :disabled="loading || isExcelRequest"
                      >
                        <option
                          :value="num"
                          v-for="(num, i) in [10, 50, 100, 999]"
                          :key="i"
                          v-html="num == 999 ? 'Semua' : num"
                        />
                      </select>
                    </div>
                  </div>

                  <div class="col-auto btn-group">
                    
                    <button
                      class="btn btn-white"
                      v-html="ic('filter')"
                      @click="triggerFilter"
                      :disabled="loading || isExcelRequest"
                    ></button>
                    <button
                      class="btn btn-outline-primary"
                      @click="_createExcel"
                      :disabled="loading || isExcelRequest"
                      v-html="
                        isExcelRequest || loading
                          ? spin()
                          : ic('download') + ' Export Excel'
                      "
                    ></button>
                    <button
                      class="btn btn-outline-primary"
                      @click="_location"
                      :disabled="loading || isExcelRequest"
                    >
                      <i class="fe fe-map mr-2"></i> Lokasi Toko
                    </button>
                    <button
                      class="btn btn-outline-primary"
                      @click="_import"
                      v-html="'Import Toko'"
                    ></button>
                    <button
                      class="btn btn-primary"
                      @click="_add"
                      :disabled="loading || isExcelRequest"
                    >
                      Tambah Toko
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Skeleton
            type="table"
            :length="10"
            class="mt-3 bg-white"
            v-if="loading"
          />

          <Nodata v-if="!loading && data_laporan.data.length == 0" />

          <div class="box" v-if="!loading && data_laporan.data.length > 0">
            <div class="card">
              <div class="table-responsive">
                <table
                  class="
                    table table-vcenter table-hover
                    card-table
                    table-striped table-control
                  "
                >
                  <thead>
                    <tr class="text-muted">
                      <th>Comp</th>
                      <th>No Acc</th>
                      <th>Cust No</th>
                      <th>Nama Toko</th>
                      <th>Alamat</th>
                      <th>Tipe</th>
                      <th>Tipe Harga</th>
                      <th>Kelurahan / Desa</th>
                      <th>Tags</th>
                      <th>Tim</th>
                      <th>Depo</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in data_laporan.data" :key="i">
                      <td>
                        <span class="badge bg-blue-lt mr-2">{{
                          row.kode_perusahaan
                        }}</span>
                      </td>
                      <td>{{ row.no_acc }}</td>
                      <td>{{ row.cust_no }}</td>
                      <td>{{ row.nama_toko }}</td>
                      <td>{{ row.alamat }}</td>
                      <td>{{ row.tipe }}</td>
                      <td>{{ row.tipe_harga }}</td>
                      <td>{{ row.kelurahan }}</td>
                      <td class="overflow-auto">
                        <span v-if="row.tags.length > 0" class="badge badge-pill bg-blue" style="margin-right: 3px;;" v-for="(tag, index) in row.tags" :key="index">{{ tag }} </span>
                      </td>
                      <td>{{ row.nama_tim }}</td>
                      <td>{{ row.nama_depo }}</td>
                      <td class="p-0 pos-relative">
                        <div class="btn-group option center">
                          <button
                            class="btn btn-white btn-pill"
                            @click="_detail(row)"
                            v-html="ic('eye')"
                          />
                          <button
                            class="btn btn-white btn-pill"
                            @click="_edit(row)"
                            v-html="ic('edit')"
                          />
                          <button
                            class="btn btn-white btn-pill"
                            @click="_clone(row.id)"
                            v-html="ic('copy')"
                          />
                          <button
                            class="btn btn-white btn-pill text-danger"
                            @click="_delete(row.id)"
                            v-html="ic('trash')"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <b-pagination
            v-if="!loading && data_laporan.data.length"
            align="center"
            class="mt-5"
            :total-rows="data_laporan.meta.total"
            v-model="data_filter.page"
            v-on:input="_get"
            :per-page="data_filter.per_page"
          />
        </div>
      </div>
    </div>

    <LokasiToko
      :config.sync="location.config"
      :initData="location.data"
      :dismiss.sync="location.dismiss"
      :isSubmit.sync="location.isSubmit"
      @submit="location.action"
    />

    <FormToko
      :config.sync="form.config"
      :initData="form.data"
      :dismiss.sync="form.dismiss"
      :isSubmit.sync="form.isSubmit"
      @submit="form.action"
    />

    <Confirm
      :id.sync="confirm.id"
      :title.sync="confirm.title"
      :isSubmit.sync="confirm.isSubmit"
      @submit="confirm.action"
    />

    <DetailToko
      :config.sync="detail.config"
      :initData="detail.data"
      :dismiss.sync="detail.dismiss"
      :isSubmit.sync="detail.isSubmit"
      @submit="detail.action"
    />

    <FormFilter />

    <FormImport
      :config.sync="formImport.config"
      :initData="formImport.data"
      :listErrors.sync="formImport.listErrors"
      :isSubmit.sync="formImport.isSubmit"
      @template="formImport.downloadTemplate"
      @submit="formImport.action" 
    />

  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import LokasiToko from "./modals/lokasi-toko.vue";
import FormToko from "./modals/form-toko.vue";
import DetailToko from "./modals/detail-toko.vue";
import FormFilter from "./modals/filter.vue";
import FormImport from "./modals/form-import.vue";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "Toko",
  components: { LokasiToko, FormToko, DetailToko, FormFilter, FormImport },

  data() {
    return {
      auth: {},

      location: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => {},
      },

      form: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => {},
      },

      confirm: {
        id: null,
        title: null,
        isSubmit: false,
        action: () => {},
      },

      detail: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => {},
      },
      filter: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => {},
      },

      formImport: {
        config: { view: false, title: null },
        listErrors: [],
        isSubmit: false,
        action: () => { },
        downloadTemplate: () => { },
      },

      isExcelRequest: false,
    };
  },

  mixins: [helper],
  computed: {
    ...mapState(["loading"]),
    ...mapState("toko", {
      data_filter: (state) => state.data_filter,
      data_laporan: (state) => state.data_laporan,
    }),
  },
  methods: {
    ...mapActions("toko", ["triggerFilter", "getLaporan","importBulkToko"]),
    _get(params) {
      this.getLaporan();
    },

    _add() {
      this.form.config = { view: true, title: "Tambah Toko" };
      this.form.data = null;
      this.form.action = (formData) => {
        this.axios
          .post("toko", formData)
          .then((res) => {
            this._get({ silent: true });
            this.toast("Berhasil ditambahkan");

            this.form.config.view = false;
          })
          .catch((err) => {
            this.onError(err);
            this.form.isSubmit = false;
          });
      };
    },

    _edit(data) {
      this.form.config = { view: true, title: "Edit Toko" };
      data.is_pkp = data.is_pkp == 1 ? true : false;
      this.form.data = data;
      this.form.action = (formData) => {
        this.axios
          .put("toko/" + data.id, formData)
          .then(() => {
            this._get({ silent: true });
            this.toast("Berhasil diperbarui");
            this.form.config.view = false;
          })
          .catch((err) => {
            this.onError(err);
            this.form.isSubmit = false;
          });
      };
    },

    _clone(id) {
      this.axios
        .post("toko/duplicate/" + id)
        .then((res) => {
          this._get({ silent: true });
          this.toast(res.data.message);
        })
        .catch((err) => {
          this.onError(err);
          this.confirm.isSubmit = false;
        });
    },

    _delete(id) {
      this.confirm.id = id;
      this.confirm.title = "Yakin ingin menghapus data toko ini?";
      this.confirm.action = () => {
        this.axios
          .delete("toko/" + id)
          .then(() => {
            this._get({ silent: true });
            this.toast("Berhasil dihapus");
            this.confirm.id = null;
          })
          .catch((err) => {
            this.onError(err);
            this.confirm.isSubmit = false;
          });
      };
    },

    _detail(data) {
      this.detail.config = { view: true, title: "Detail Toko" };
      this.detail.data = data;
    },

    _pageChange(page) {
      this.paginate.currentPage = page;
      this._get();
    },

    _search(keyword) {
      var io = this.data_filter.tipe_keyword.indexOf("Keyword");

      if (io > -1) {
        this.data_filter.keyword.splice(io, 1);
        this.data_filter.tipe_keyword.splice(io, 1);
      }

      this.data_filter.keyword.push(keyword);
      this.data_filter.tipe_keyword.push("Keyword");
      this._get();
    },

    _location() {
      this.location.config = { view: true, title: "Lokasi Toko" };
    },
    _createExcel() {
      let per_page_res = this.data_filter.per_page;
      this.isExcelRequest = true;
      this.data_filter.per_page = "all";
      this.axios
        .get("toko", { params: this.data_filter })
        .then((res) => {
          this.isExcelRequest = false;
          let data_res = res.data.data;
          let dataExcel = [];
          for (let i = 0; i < data_res.length; i++) {
            let data = data_res[i];
            let res = {
              Depo: data.nama_depo,
              "Kode Toko": data.no_acc,
              "Cust No": data.cust_no,
              "Nama Toko": data.nama_toko,
              Tipe: data.tipe,
              "Tipe Desc": data.tipe_2,
              Harga: data.tipe_harga,
              Pemilik: data.pemilik,
              Kelurahan: data.kelurahan,
              Kecamatan: data.kecamatan,
              Kabupaten: data.kabupaten,
              Alamat: data.alamat,
              "Kode Pos": data.kode_pos,
              Telp: data.telepon,
              "Tipe Pembayaran": data.k_t,
              TOP: data.top,
              Limit: data.limit,
              NPWP: data.npwp,
              "Nama PKP": data.nama_pkp,
              "Alamat PKP": data.alamat_pkp,
              "No KTP": data.no_ktp,
              "Nama KTP": data.nama_ktp,
              "Alamat KTP": data.alamat_ktp,
              Tim: data.nama_tim,
              "Hari Kunjungan": data.hari,
              "Minggu Kunjungan": data.minggu,
              "Lock Order": data.lock_order,
              "Tags": data.tags.join(", "),
              "Id Toko": data.id,
            };
            dataExcel.push(res);
          }
          this.data_filter.per_page = per_page_res;
          this.createExcel({
            data: dataExcel,
            filename: "Toko - " + this.dTime("datetime"),
          });
        })
        .catch((err) => {
          this.isExcelRequest = false;
          this.onError(err);
        });
    },
    _import(){
      this.formImport.config = { view: true, title: "Import Barang" };
      this.formImport.listErrors = [];
      this.formImport.downloadTemplate = () => {
        this._templateImportBatchToko()
      }
      this.formImport.action = async (file) => {
        const response = await this.importBulkToko(file)
        const data = response.data 
        const invalidRequest = data.filter(item => item.valid === false)
        if (invalidRequest.length > 0){
          this.formImport.listErrors = invalidRequest;
          this.toast("Ada beberapa data yang gagal diimport")
          return
        }
        this.formImport.isSubmit = false;
        this.formImport.config = { view: false, title: "" };
      }
    },
    
    _templateImportBatchToko(){
      const template = [{
        "nama_toko": 'e.g: PT.Kembar Putra, Foodbuy (Wajib diisi)',
        "tipe": 'e.g: R1,KOP,R2,W,MM,SM,HRC,HCO,PND (Wajib diisi)',
        "tipe_2": 'e.g: KIOS,INSTITUSI,SUPERMARKET,GROSIR (plain text mirip seperti tag)',
        "tipe_3": 'e.g: RO,NOO (Boleh kosong)',
        "tipe_harga": 'e.g: rbp,wbp,hcobp,kfc,dbp,dbp+3,gt,mt,harga 6,harga 5,harga 1,mtbp,harga trading,rsm,harga famili boga,motoris,frestive,pp,gl,artasedana,atlas,ps,maya,idm,dash,pepito,mm,mt idm,r nusa,r nusa khusus ii,r nusa khusus,r nusa khusus iii,r nusa khusus v,r nusa khusus iv,r nusa khusus vi,dbpg,fresh (Wajib isi)',
        "pemilik": 'e.g: Budi (Wajib diisi)',
        "id_depo": 'e.g: 1-36 (Gunakan id_depo hubungi admin untuk mendapatkan info ID )',
        "kode_perusahaan": 'e.g: KPM,AKM,FBN (Boleh kosong jika id_depo terisi)',
        "nama_depo": 'e.g: Denpasar,Kuta,Bangli (Gunakan capitalize, boleh tidak diisi jika id_depo terisi)',
        "no_acc": 'e.g: AC-105xxx (Boleh kosong)',
        "cust_no": 'e.g: 1025xxxxx (Boleh kosong)',
        "id_logistik": 'e.g: 1-23 (Boleh kosong, hubungi admin untuk mendapatkan ID)',
        "id_group": 'e.g: 1-23 (Boleh kosong, hubungi admin untuk mendapatkan ID)',
        "kode_mars": 'e.g: 1-10000 (Boleh kosong, hubungi admin MARS untuk mendapatkan ID )',
        "telepon": 'e.g: 081xxxxx (Harus 12-15 digit)',
        "alamat": 'e.g: Badung No.10 xxxx (Wajib isi)',
        "id_grup_logistik": 'e.g: 1-23 (Boleh kosong, hubungi admin untuk mendapatkan ID)',
        "id_mitra": 'e.g: 1 (Boleh kosong, hubungi admin untuk mendapatkan ID)',
        "lock_order": 'e.g: 1/0 (0 bisa transaksi, 1 untuk lock transaksi)',
        "lock_disc_retur": 'e.g: 1/0 (Untuk mengembalikan retur discount dari toko)',
        "gps": 'e.g: -8xxxxx, 11x,xxxxxx (Boleh kosong)',
        "latitude": 'e.g: -8xxxxx (Boleh kosong)',
        "longitude": 'e.g: 11x,xxxxxx (Boleh kosong)',
        "kode_pos": 'e.g: 8xxxx (Wajib diisi)',
        "id_kelurahan": 'e.g: 1-99 (Boleh kosong, jika nama_kelurahan isi. hubungi admin untuk mendapatkan ID)',
        "nama_kelurahan": 'e.g: GILIMANUK(Boleh kosong, jika id_kelurahan isi),',
        "kode_eksklusif": 'e.g: 1xxxxx (Boleh kosong)',
        "id_gudang_toko": 'e.g: 1-99 (Boleh kosong, jika gudang_penjualan isi. hubungi admin untuk mendapatkan ID)',
        "gudang_penjualan": 'e.g: 1-99 (Boleh kosong, jika id_gudang_toko isi. hubungi admin untuk mendapatkan ID)',
        "id_gudang_bs_toko": 'e.g: 1-99 (Boleh kosong, jika gudang_retur isi. hubungi admin untuk mendapatkan ID)',
        "gudang_retur": 'e.g: 1-99 (Boleh kosong, jika id_gudang_bs_toko isi. hubungi admin untuk mendapatkan ID)',
        "k_t": 'e.g: tunai/kredit (Wajib diisi)',
        "top": 'e.g: 0-99 (Term of payment)',
        "limit": 'e.g: 0-99999 (Wajib diisi)',
        "hari": 'e.g: senin - minggu (Wajib diisi dengan huruf kecil)',
        "minggu": 'e.g: 1, 2, 3, 4, 1-4, 1&3, 2&4 (Wajib diisi)',
        "id_tim": 'e.g: 1-99 (Boleh kosong, jika nama_tim isi. hubungi admin untuk mendapatkan ID)',
        "nama_tim": 'e.g: 1-99 (Boleh kosong, jika id_tim isi. hubungi admin untuk mendapatkan ID)',
        "is_pkp": 'e.g: 1/0 (1 jika pkp, 0 jika tidak pkp)',
        "npwp": 'e.g: 1.90.9xxxxxxx (Wajib isi jika is_pkp 1)',
        "nama_pkp": 'e.g: Kembarxxxx (Wajib isi jika is_pkp 1)',
        "alamat_pkp": 'e.g: Badungxxxxx (Wajib isi jika is_pkp 1)',
        "no_ktp": 'e.g: 510xxxxx (isi dengan 16 digit) (Wajib diisi)',
        "nama_ktp": 'e.g: Kembarxxxx (Wajib diisi)',
        "alamat_ktp": 'e.g: Badungxxxxx (Wajib diisi)',
      }]

      this.createExcel({
        data: template,
        filename: "template_create_bulk_toko"
      });
    }
  },

  mounted() {
    this.auth = JSON.parse(localStorage.user);
    
    this._get();
  },
};
</script>
